<script>
export default {
  name: 'SecondaryPinnedNavItem',
  props: {
    menuItem: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isActive() {
      const currentRouteName = this.$store.state.route.name || '';
      if (!this.menuItem.toStateName) return false;
      return currentRouteName.includes(this.menuItem.toStateName);
    },
    // One class per state rather than stacking two `bg-*` utilities of equal
    // specificity, where stylesheet order — not the route — would pick the
    // winner.
    surfaceClass() {
      return this.isActive
        ? 'bg-orange-light-4 dark:bg-orange-dark-4'
        : 'bg-orange-light-5 dark:bg-orange-dark-5';
    },
  },
};
</script>

<template>
  <li class="mx-2 mt-1">
    <router-link
      :to="menuItem.toState"
      class="flex items-center justify-center w-full h-8 gap-2 px-2 transition-colors rounded-xl text-basic-primary dark:text-basic-primary hover:bg-orange-light-4 dark:hover:bg-orange-dark-4"
      :class="surfaceClass"
    >
      <fluent-icon
        :icon="menuItem.icon"
        :view-box="menuItem.iconType === 'claudia' ? '0 0 16 16' : '0 0 24 24'"
        class="shrink-0"
        size="16"
      />
      <span class="text-sm font-medium leading-[22px] truncate">
        {{ $t(`SIDEBAR.${menuItem.label}`) }}
      </span>
    </router-link>
  </li>
</template>
